// Hero image and waves variables
const heroImage = document.querySelector('.hero-image__src');
const heroWaves = document.querySelector('.hero__waves');

window.addEventListener("load", () => {
  if (heroImage) {
    // Throttle scroll behavior
    window.addEventListener('scroll', _.throttle(() => {
      const scrollingDistance = window.scrollY;
      /* global motionQuery */
      if (!motionQuery || motionQuery.matches) {
        // Disable hero parallax if `prefers-reduced-motion`
        heroImage.style.transform = '';
        heroWaves.style.transform = '';
      } else {
        // Enable hero parallax
        heroImage.style.transform = `translateY(${scrollingDistance * 0.2}px) scale(1.1)`;
        heroWaves.style.transform = `translateY(-${scrollingDistance * 0.1}px)`;
      }
    },
    {
      capture: true,
      passive: true,
    }, 50));
  }
});